/* eslint-disable jsx-quotes */
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import s from './cardHover.module.css';

// TODO add hide image from hover item option to save space
// faWindowRestore,  faTimes

const Expandable = ({ text }) => {
  const [expanded, setExpanded] = useState(false);

  const limit = 75; // number of characters to break
  if (text.length <= limit) return text;

  const toggleExpanded = () => { setExpanded(!expanded); };

  const content = (!expanded) ? text.substring(0, limit) : text;
  const icon = (!expanded) ? 'plus-square' : 'minus-square';

  return (
    <div className='d-flex'>
      <div style={{ width: '90%' }}>{content}</div>
      <div style={{ width: '10%', textAlign: 'right' }}>
        <FontAwesomeIcon icon={['far', icon]} size='lg' style={{ margin: '2px 4px 0 0' }} onClick={toggleExpanded} />
      </div>
    </div>
  );

};


const tx = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi asperiores molestias consequuntur aut assumenda dolorem hic. Praesentium, quia? Vero cumque, quis expedita, natus quidem rerum inventore odit molestias officiis, maxime voluptatibus magni cupiditate. Eius enim natus excepturi at dolore ullam similique fugit tempora. Ullam est quo recusandae laudantium esse nesciunt.';

const genRows = () => (
  <>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>DorsalAttributes</td>
      <td className={s.tableCell}><b><Expandable text={tx} /></b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>TypeOfEyes</td>
      <td className={s.tableCell}><b>more or less normal</b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>TypeOfEyes</td>
      <td className={s.tableCell}><b>more or less normal</b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>DorsalAttributes</td>
      <td className={s.tableCell}><b><Expandable text={tx} /></b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>TypeOfMouth</td>
      <td className={s.tableCell}><b>more or less normal</b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>TypeOfMouth</td>
      <td className={s.tableCell}><b>more or less normal</b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>DorsalAttributes</td>
      <td className={s.tableCell}><b><Expandable text={tx} /></b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>TypeOfEyes</td>
      <td className={s.tableCell}><b>more or less normal</b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>TypeOfMouth</td>
      <td className={s.tableCell}><b>more or less normal</b></td>
    </tr>
    <tr className={s.tableRow}>
      <td className={s.tableCell}>Weight</td>
      <td className={s.tableCell}><b>363800.0</b></td>
    </tr>
  </>
);

const HoverItem = ({ data }) => {

  // right or left pop param ?
  const { title, num, img } = data;

  const tableRows = genRows();

  const Img = img
    ? (
      <div className={s.imgContainer}>
        <img className={s.imgStyle} src='https://source.unsplash.com/random/100x60' alt='hover-img' />
      </div>
    )
    : '';

  return (
    <div className={s.cont}>
      <div className={s.marginFix}>

        <div className={s.head}>
          <div className={s.headPart1}>
            <h5 className={s.matchNumber}>{num}</h5>
            <h4>{title}</h4>
          </div>
          <div className={s.headPart2}>
            <FontAwesomeIcon fixedWidth icon={['far', 'window-restore']} size='lg' />
            <FontAwesomeIcon fixedWidth icon={['fas', 'times']} size='lg' className={s.headIcon} />
          </div>
        </div>

        {Img}

        <div className={s.tableCont}>
          <table id='popUp'>
            <tbody>
              <tr className='popUp'>
                <th className='popUp'><u>Attribute</u></th>
                <th className='popUp'><u>Value</u></th>
              </tr>

              {tableRows}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );

};


const t = { num: 1, title: 'Alburnus Thesalicus', img: 'https://source.unsplash.com/random/170x90' };

// const T = React.forwardRef((props, ref) => (
//   <Popover id={s.popoverCont} ref={ref} {...props}>
//     <HoverItem data={t} />
//   </Popover>
// ));

/* TODO: Refactor Styling |/ Original Hover Card css from hippalus is better */
const T = React.forwardRef((props, ref) => (
  <div ref={ref} {...props}>
    <HoverItem data={t} />
  </div>
));

// const T = <div><HoverItem data={t} /></div>;

export default T;
